import {
  Component,
  ChangeDetectorRef,
  inject,
  DestroyRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  IconComponent,
  TextareaComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-submit-rejection-dialog',
  templateUrl: './submit-rejection-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    IconComponent,
    TextareaComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class SubmitRejectionDialogComponent implements DialogComponentI<void, string> {
  private readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  private readonly cdRef = inject(ChangeDetectorRef);

  private readonly destroyRef = inject(DestroyRef);
  public messageControl = new FormControl('', Validators.required);

  constructor() {
    this.messageControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdRef.detectChanges());
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean): void {}

  public submit(): void {
    this.dialogRef.close(this.messageControl.value);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
